@if (formGroup) {
  <div class="op-preview">
    <!-- The Order Protection widget card (as it sits above the cart's checkout area). -->
    <div
      class="op-preview__card"
      [style.border]="cardBorder"
      [style.border-radius]="cardBorderRadius"
      [style.padding]="cardPadding">
      @if (imageUrl) {
        <img class="op-preview__image" [src]="imageUrl" alt="" />
      } @else {
        <div class="op-preview__image op-preview__image--placeholder" aria-hidden="true"></div>
      }

      <div class="op-preview__info">
        <div class="op-preview__title-row">
          <span class="op-preview__title">{{ title }}</span>
          @if (hasInfo) {
            <span class="op-preview__info-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
              </svg>
            </span>
          }
        </div>
        @if (subtitle) {
          <div class="op-preview__subtitle" [style.color]="subtitleColor || null">{{ subtitle }}</div>
        }
      </div>

      <div class="op-preview__right">
        <span class="op-preview__price">{{ formattedPrice }}</span>
        <!-- Fixed-width slot so the price keeps the same position regardless of which selector (if any) shows. -->
        <span class="op-preview__selector">
          @if (isToggle) {
            <span
              class="op-preview__toggle"
              [class.op-preview__toggle--on]="isSelected"
              [style.background-color]="isSelected ? selectorColor : null">
              <span class="op-preview__toggle-knob" [style.left.px]="isSelected ? toggleKnobOn : toggleKnobOff"></span>
            </span>
          }
          @if (isCheckbox) {
            <span
              class="op-preview__checkbox"
              [style.background-color]="isSelected ? selectorColor : 'transparent'"
              [style.border-color]="selectorColor">
              @if (isSelected) {
                <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" aria-hidden="true">
                  <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <pdq-divider></pdq-divider>

    <!-- Estimated total (sample cart) — matches the Figma preview. -->
    <div class="op-preview__totals">
      <span class="op-preview__totals-label">{{ itemCountLabel }}</span>
      <span class="op-preview__totals-value">{{ estimatedTotal }}</span>
    </div>
    <div class="op-preview__totals-hint">shipping calculated at checkout</div>

    <!-- Checkout area: quick-checkout uses the widget's own button; toggle/checkbox use the native cart button. -->
    @if (isQuickCheckout) {
      <button
        type="button"
        class="op-preview__checkout"
        [ngStyle]="quickButtonStyle"
        (mouseenter)="quickHover = true"
        (mouseleave)="quickHover = false">
        @if (quickIconSvg) {
          <span class="op-preview__checkout-icon" [style.color]="quickIconColor" [innerHTML]="quickIconSvg"></span>
        } @else if (quickIconUrl) {
          <img class="op-preview__checkout-icon" [src]="quickIconUrl" alt="" />
        }
        <span>{{ quickButtonLabel }}</span>
      </button>
      <div
        class="op-preview__continue"
        [ngStyle]="continueStyle"
        [innerHTML]="continueWithoutHtml"
        (mouseenter)="continueHover = true"
        (mouseleave)="continueHover = false"></div>
    } @else {
      <button type="button" class="op-preview__checkout op-preview__checkout--default">Checkout</button>
      <div class="op-preview__continue">Continue Shopping</div>
    }
  </div>
}
